const NO_REQUIERE = "NO_REQUIERE_AUTORIZACION";

const normalizar = (value) =>
  String(value ?? "")
    .trim()
    .toUpperCase();

const booleanString = (value) => {
  if (typeof value === "boolean") return value ? "true" : "false";
  const text = String(value ?? "").trim().toLowerCase();
  if (text === "true") return "true";
  if (text === "false") return "false";
  return String(value ?? "").trim();
};

export const esReglaNoRequiereAutorizacion = (regla) => {
  const candidatos = [
    regla?.ruleId,
    regla?.idRegla,
    regla?.nombre,
    regla?.valorModificado,
    regla?.accion?.decision,
    regla?.accion?.codigo,
    regla?.decision,
    regla?.codigoAccion,
  ];

  return candidatos.some((value) => normalizar(value).includes(NO_REQUIERE));
};

export const invertirValorBooleano = (value) => {
  const normalized = booleanString(value).toLowerCase();
  if (normalized === "true") return "false";
  if (normalized === "false") return "true";
  return booleanString(value);
};

export const construirCondicionesNoRequiereDesdeElegibilidad = (reglaElegibilidad) => {
  const idRegla = normalizar(reglaElegibilidad?.ruleId || reglaElegibilidad?.idRegla || reglaElegibilidad?.nombre);
  if (idRegla.includes("ELEG_R01_ASOCIADO_NO_ACTIVO")) {
    return [{ tipo: "activo", operador: "==", valor: "true" }];
  }
  if (idRegla.includes("ELEG_R02_SIN_COBERTURA_ACTIVA")) {
    return [{ tipo: "cobertura", operador: "==", valor: "true" }];
  }
  if (idRegla.includes("ELEG_R04_ASOCIADO_JUDICIALIZADO")) {
    return [{ tipo: "judicializado", operador: "==", valor: "false" }];
  }
  if (idRegla.includes("ELEG_R05_ASOCIADO_EMPADRONADO")) {
    return [{ tipo: "empadronado", operador: "==", valor: "false" }];
  }
  if (idRegla.includes("ELEG_NIVELMOROSIDAD")) {
    return [{ tipo: "moroso", operador: "==", valor: "false" }];
  }

  const condiciones = Array.isArray(reglaElegibilidad?.condiciones)
    ? reglaElegibilidad.condiciones
    : [];

  return condiciones
    .map((cond) => {
      const tipo = String(cond?.tipo ?? cond?.atributo ?? "").trim();
      const operador = String(cond?.operador ?? "==").trim() || "==";
      const valor = cond?.valor ?? cond?.valorComparacion;

      if (!tipo || tipo.toLowerCase() === "condicionmedica") return null;
      if (!["=", "==", "IGUAL"].includes(operador.toUpperCase())) return null;

      return {
        tipo,
        operador: "==",
        valor: invertirValorBooleano(valor),
      };
    })
    .filter(Boolean);
};

export const formatearReglaElegibilidad = (regla) => {
  const id = String(regla?.ruleId || regla?.idRegla || "").trim();
  const descripcion = String(regla?.descripcion || regla?.nombre || "").trim();
  return descripcion && descripcion !== id ? `${id} - ${descripcion}` : id;
};
